import { Box, Typography } from "@mui/material";
import HeroAboutVideo from "../HeroAboutVideo";
import { ProductHeroVideo } from "../../constant"


const tabsData = [
  {
    label: "EHS",
    key: "1",
    videoUrl: ProductHeroVideo
  },
  {
    label: "EHG",
    key: "2",
    videoUrl: ProductHeroVideo
  },
  {
    label: "Carbon",
    key: "3",
    videoUrl: ProductHeroVideo
  },
];

export default function ProductLanding({ title, subTitle, isNetzero,url = null }) {
  return (
    <Box sx={{ position: "relative", minHeight: { sx: "50vh", md: "100vh" }, overflow: "hidden" }}>
      {/* Background Video */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          zIndex: -1, // Send it behind all content
          overflow: "hidden",
        }}
      >
        <video
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        >
          <source src="/HomeBGVideo.webm" type="video/webm" />
          Your browser does not support the video tag.
        </video>
      </Box>

      {/* Content Overlay */}
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          width: "100%",
          height: "100%",
          padding: { xs: 2, sm: 4, md: 6 },
          display: "flex",
          justifyContent: "space-between",
          flexDirection: 'column',
          margin: "0 auto",
          alignItems: "center",
        }}
      >
        <Box
          display="flex"
          justifyContent="center"
          flexDirection="column"
          alignItems="center"
          sx={{
            width: "100%",
            maxWidth: "1200px",
            textAlign: "center",
            py: 4,
            mt: 4
          }}
        >
          <Typography
            variant="h2"
            sx={{
              background: "linear-gradient(135deg, #6366F1 0%, #3B82F6 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontSize: { xs: "24px", sm: "32px", md: "48px" },
              fontWeight: 700,
              mb: 2,
              textAlign: "center",
              letterSpacing: '-2.4px',
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            {title}
          </Typography>
          <Typography
            sx={{
              color: "#8C8CC2",
              fontSize: { xs: "14px", md: "16px" },
              lineHeight: 1.8,
              textAlign: "center",
              marginTop: 2,
            }}
          >
            {subTitle}
          </Typography>
        </Box>
        <HeroAboutVideo
          tabsData={tabsData}
          isNetzero={isNetzero}
          isProduct={true}
          url={url}
        />
      </Box>
    </Box>
  );
}
